<template>
  <div>
    <event-header :event="event" />

    <order-table :event="$route.params.id" :show-button="true" />
  </div>
</template>

<script>
import OrderTable from "@/components/OrderTable";
import ordersClient from "@/api/central/orders";
import EventHeader from "@/components/EventHeader";
import dayjs from "dayjs";
import axios from "axios";

export default {
  props: ["event", "title"],

  components: {
    OrderTable,
    EventHeader,
  },
};
</script>
